import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "page-link" }

import { ref, inject, onMounted } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerPagination',
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const selected = ref('a');

const store = useStore();
const actProperty: any = inject('actProperty');

const links = [
  "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", 
  "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", 
  "0-9",
];

onMounted(() => {
  init();
});

const init = async () => {
  await getCustomersAction(selected.value);
};

const onClick = (event: any) => {
  selected.value = event;
  getCustomersAction(selected.value);
  emit("click", event);
};

const getCustomersAction = async (starts_with: string) => {
  try {
    await store.dispatch('usermanagement/getCustomers', starts_with);
  } catch (err: any) {
    actProperty.displayError(err)
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link, $index) => {
        return _createElementVNode("li", {
          key: $index,
          class: _normalizeClass(["page-item", {active: selected.value === link}]),
          onClick: ($event: any) => (onClick(link))
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(link.toUpperCase()), 1)
        ], 10, _hoisted_2)
      }), 64))
    ])
  ]))
}
}

})